import { ResponsiveEnums } from '@yodlee/common-components/dist/types/enumerations';
import Axios from 'axios';
import cookie from "js-cookie";
import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { BrowserCompatibility } from '../components';
import LargeScreenOnly from '../components/large-screen-only';
import { UrlConfigs } from '../configurations';
import { BrowserUtils, DataUtils } from '../utilities';
import { getAuthenticationDetails } from '../utilities/authentication';
import HomePage from './home';

const keepAliveInterval = setInterval(() => {
    DataUtils.keepAlive(getAuthenticationDetails()).get().catch((error) => console.error(error));
}, 5 * 60 * 1000)

var checkCookie = function () {
    var lastCobrandId = cookie.get("brandId");
    return function () {
        var currentCobrandId = cookie.get("brandId");
        if (currentCobrandId !== lastCobrandId) {
            console.info("Cookie changed, refreshing the page")
            lastCobrandId = currentCobrandId;
            window.location.reload();
        }
    };
}();
window.setInterval(checkCookie, 300); // run every 300 ms

const redirectToYccLogin = () => {
    const returnUrl = cookie.get("yccUrl");
    const brandName = cookie.get("brandName");
    let modifiedReturnUrl = returnUrl;
    if (returnUrl && brandName) {
        try {
            modifiedReturnUrl = new URL(returnUrl).origin + "/ycc/logout." + brandName + ".do";
        } catch (e) { console.error(e) }
    }
    clearInterval(keepAliveInterval);
    window.open(modifiedReturnUrl, "_self");
}
window.addEventListener("unauthorisedAccess", redirectToYccLogin);

Axios.interceptors.request.use((config: any) => {
    return { ...config, withCredentials: true, headers: undefined }
})

Axios.interceptors.response.use((config: any) => {
    if (!config.config.url?.includes(UrlConfigs.API_URLS.KEEP_ALIVE)) {
        window.dispatchEvent(new Event('resetTimer'));
    }
    return config;
}, (error: any) => {
    if (error?.response?.status === 401 && !window.location.href.includes(UrlConfigs.ROUTES.UNSUBSCRIBE_NOTIFICATION.url)) {
        redirectToYccLogin();
        throw new Axios.Cancel('Unauthorized');
    }
    return Promise.reject(error);
});


const IndexPage: React.FC = () => {
    const [continueAnyway, setContinueAnyway] = useState(false);
    let isMD = useMediaQuery({ minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD });

    return (
        (BrowserUtils.isValidBrowser || continueAnyway) ?
            (
                isMD ?
                    <HashRouter>
                        <Switch>
                            <Route path={UrlConfigs.ROUTES.ROOT.url} component={HomePage} />
                        </Switch>
                    </HashRouter> :
                    <LargeScreenOnly />
            ) :
            <BrowserCompatibility allowProceed={BrowserUtils.isValidBrowserForProceed} onProceedClick={() => setContinueAnyway(true)} />
    )
}

export default IndexPage;